const checkMinStayDay = (data) => {
  if (data?.diff && data?.rate?.min_stay) {
    if (data?.rate?.min_stay > data?.diff) {
      return false;
    } else {
      return true;
    }
  }
  if (data?.rate?.min_stay === undefined) return true;
  console.error(
    "Ошибка в данных, разница в днях ",
    data?.diff,
    ", или min_stay",
    data?.rate?.min_stay
  );
  return false;
};

const morph = (int, array) => {
  if (!int) return null;
  const returnText =
    (array = array || [
      { id: 1, var1: "го", var2: "го" },
      { id: 2, var1: "ух", var2: "ех" },
      { id: 3, var1: "ми", var2: "ти" },
    ]) &&
    array[
      int % 100 > 4 && int % 100 < 20
        ? 2
        : [2, 0, 1, 1, 1, 2][int % 10 < 5 ? int % 10 : 5]
    ];
  if (returnText.id === 2) {
    if (int % 2 || int === 4) {
      return returnText.var2;
    }
    return returnText.var1;
  }
  if (returnText.id === 3) {
    if ([7, 8].includes(int)) {
      return returnText.var1;
    }
    return returnText.var2;
  }
  if (returnText.id === 1) {
    return returnText.var1;
  }
};

const fulRowMorph = (int) => {
  const dayMorphData = [
    { id: 1, var1: "дня", var2: "дня" },
    { id: 2, var1: "дней", var2: "дней" },
    { id: 3, var1: "дней", var2: "дней" },
  ];

  // const pathOne = morph(int);
  const pathTwo = morph(int, dayMorphData);

  // return `${int} ${pathTwo}`;
  return `${int} суток`;
};

export { fulRowMorph, checkMinStayDay, morph };
